export default __webpack_public_path__ + "static/media/x_wdt_c_0.ad17e448.mp3";